var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvestorWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.2504 13.8853L5.5096 10.6261L7.86661 12.9831L11.6759 9.17388L13.1699 10.668V6.5013H9.00327L10.4974 7.99538L7.86661 10.6261L5.5096 8.26904L1.38804 12.3906C0.926489 11.3551 0.669922 10.2082 0.669922 9.00129C0.669922 4.39893 4.40089 0.667969 9.00327 0.667969C13.6056 0.667969 17.3366 4.39893 17.3366 9.00129C17.3366 13.6037 13.6056 17.3346 9.00327 17.3346C6.22516 17.3346 3.76456 15.9752 2.2504 13.8853Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestorWhite);
export default __webpack_public_path__ + "static/media/investor-white.fea7916a00e72acb1c6e3ef2af379da7.svg";
export { ForwardRef as ReactComponent };